var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note-editor"},[_c('div',{staticClass:"note-editing-area"},[_c('div',{staticClass:"note-editable",domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }